import { render } from "./PCIndex.vue?vue&type=template&id=615696d6"
import script from "./PCIndex.vue?vue&type=script&lang=js"
export * from "./PCIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__